<template>
    <MobMenu v-if="!isTgApp"
        :headerTxt="content[lang_].title"
        :footerTxt="content[lang_].footer"
        :items="[]">
        <template v-slot:body>
            <div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:50px" @click="popup=true">
                <div class="flex mr-3 align-items-center">
                    <Avatar v-if="userPhoto" class="text-600" size="small" :image="userPhoto" shape="circle"/>
                    <Avatar v-else class="text-600" size="small" icon="pi pi-telegram" shape="circle"/>
                </div>
                <div v-if="userTelegram" class="flex flex-1 justify-content-left align-items-center">
                    <span class="text-600">@{{ userTelegram }}</span>
                </div>
                <div v-else class="flex flex-1 justify-content-left align-items-center">
                    <span class="text-600">{{ content[lang_].bind }}</span>
                </div>
                <div class="flex justify-content-right align-items-center">
                    <span v-if="userTelegram" class="text-sm text-blue-500">{{ content[lang_].changeBtn }}</span>
                    <i class="text-blue-500 ml-2" :class="'pi pi-angle-right'" />
                </div>
            </div>
            <div v-if="userTelegram" class="w-full flex flex-row px-3 py-2 border-100" style="min-height:50px" @click="popup=true"
                :class="(!userSubscribed) ? 'bg-yellow-100 cursor-pointer' : ''">
                <div class="flex mr-3 align-items-center">
                    <Avatar :class="(!userSubscribed) ? 'bg-yellow-200' : ''" size="small" icon="pi pi-telegram" shape="circle">
                        <icon>
                            <i class="pi pi-bell" :class="(!userSubscribed) ? 'text-yellow-700' : 'text-600'" />
                        </icon>
                    </Avatar>
                </div>
                <div v-if="userSubscribed" class="flex flex-1 justify-content-left align-items-center">
                    <span class="text-600">{{ content[lang_].enabled }}</span>
                </div>
                <div v-else class="flex flex-1 justify-content-left align-items-center">
                    <span class="text-yellow-700">{{ content[lang_].disabled }}</span>
                </div>
                <div v-if="!userSubscribed" class="flex justify-content-right align-items-center">
                    <span class="text-sm text-blue-500">{{ content[lang_].subscribe }}</span>
                    <i class="text-blue-500 ml-2" :class="'pi pi-angle-right'" />
                </div>
                <div v-else class="flex justify-content-right align-items-center">
                    <i class="text-blue-500 ml-2" :class="'pi pi-check'" />
                </div>
            </div>
        </template>
    </MobMenu>   

    <!--TG POPUP-->
    <Dialog class="w-full surface-100 border-none" modal v-model:visible="popup" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">
        
        <template #header>
            <span class="text-lg font-medium">{{ content[lang_].title }}</span>
        </template>

        <div class="w-full flex flex-column gap-4">
            <BindTgButton username="telegram.username" id="telegram.id" photo_url="telegram.photo_url"/>

            <MobMenu v-if="userTelegram"
                :headerTxt="content[lang_].subscribeTitle"
                :items="[]">
                <template v-slot:body>
                    <div class="w-full flex flex-row px-3 py-2 border-100 border-bottom-1 cursor-pointer" @click="goToBot" style="min-height:50px">
                        <div class="flex mr-3 align-items-center">
                            <Avatar class="text-600" size="small" icon="pi pi-telegram" shape="circle"/>
                        </div>
                        <div class="flex flex-1 justify-content-left align-items-center">
                            <span class="text-600">@{{ botName }}</span>
                        </div>
                        <div class="flex justify-content-right align-items-center">
                            <i class="text-blue-500 ml-2" :class="'pi pi-external-link'" />
                        </div>
                    </div>
                </template>
            </MobMenu> 

            <div v-if="userTelegram" class="w-full flex flex-column gap-2">
                <div class="w-full flex flex-row">
                    <span v-if="userSubscribed" class="text-sm text-600">{{ content[lang_].checktitle }}</span>
                    <span v-else class="text-sm text-600">{{ content[lang_].activeTitle }}</span>
                </div>
                <Button type="submit" class="w-full border-round-lg" @click="subscribe()"
                    :label="(userSubscribed) ? content[lang_].checkBtn : content[lang_].subscribe" :loading="loading" :disabled="loading"/>
            </div>
        </div>
               
        <template #footer>
            <span class="text-lg font-medium mb-5"></span>
        </template>
    </Dialog>
</template>


<script>
import Connect from         '@/assets/js/Connect.js'
import MobMenu from         '@/components/sides/menu/MobMenu.vue' 
import BindTgButton from    '@/components/widgets/BindTgButton.vue' 
import { mapActions } from  'vuex'

export default {
    data(){
        return{
            popup: false,
            loading: false,
            content: {
                en: {
                    title: 'Telegram',
                    footer: 'Bind Telegram for quick access and notifications',
                    subtitle: 'Click login to bind Telegram',
                    bind: 'Bind Telegram',
                    unbind: 'Unbind Telegram',
                    success: 'Success',
                    error: 'Error',
                    disabled: 'Alerts not enabled',
                    enabled: 'Alerts is enabled',
                    subscribe: 'Subscribe',
                    subscribeTitle: 'Subscribe to the bot for notifications',
                    checktitle: 'Check if notifications are active',
                    activeTitle: 'Activate notifications',
                    checkBtn: 'Check',
                    changeBtn: 'Change'
                },
                ru: {
                    title: 'Telegram',
                    footer: 'Привяжите Telegram для быстрого входа и получения уведомлений',
                    subtitle: 'Нажмите войти для привязки Telegram',
                    bind: 'Привязать Telegram',
                    unbind: 'Отвязать Telegram',
                    success: 'Успех',
                    error: 'Ошибка',
                    disabled: 'Уведомления не подключены',
                    enabled: 'Уведомления подключены',
                    subscribe: 'Подключить',
                    subscribeTitle: 'Подпишистесь на бота для получения уведомлений',
                    checktitle: 'Проверьте активны ли уведомления',
                    activeTitle: 'Активируйте уведомления',
                    checkBtn: 'Проверить',
                    changeBtn: 'Изменить'
                }
            },
        }
    },
    components: {
        MobMenu,
        BindTgButton
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        screenSize() { return this.$store.getters.StateScreenSize },
        userPhoto: function () { return this.$store.getters.StateUserPhoto },
        userTelegram: function () { return this.$store.getters.StateTelegramUsername },
        userVerified: function () { return this.$store.getters.StateVerified },
        userSubscribed: function () { return this.$store.getters.StateUserSubscribed },
        botName: function () { return this.connect.support_bot }
    },
    methods: {
        ...mapActions(['ActionSubscribeBot']),
        lang(value){
            return this.$t(`views.personal.profile.${value}`)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        goToBot(){
            try{
                window.open(`https://t.me/${this.botName}`, '_blank')
            } catch(e){
                console.log(e)
            }
        },
        async subscribe(){
            this.loading = true
            try {
                const request = await this.ActionSubscribeBot().then(res=>res)
                if(request.result){
                    this.showMess('success', this.content[ this.lang_ ].success, this.content[ this.lang_ ].enabled);
                } else {
                    if(request.errors) this.showMess('error', this.content[ this.lang_ ].error, request.errors[0]);
                    else this.showMess('error', this.content[ this.lang_ ].error, 'Subscription error');
                }
            } catch (error) {
                console.error(error)
            } finally {
                this.loading = false
            }
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
    },
}
</script>